import { RenderContext } from './types';
import getTimeItems from './utilities/getTimeItems';

export const MAX_ROOMS = 6;
export const MAX_ADULTS = 6;
export const MAX_CHILDREN = 4;
export const MAX_CHILDREN_AGE = 18;
export const MAX_INFANT_AGE = 3;
export const MAX_DAYS_INTERVAL = 28;

export const MIN_ADULTS = 1;

export const DEFAULT_MULTIROOM_GUESTS = 6;
export const DEFAULT_MULTIROOM_AVAILABILITY = false;
export const DEFAULT_ADULTS = 2;
export const DEFAULT_CHILDREN = 0;
export const DEFAULT_CHILDREN_AGE = 12;
export const DEFAULT_HAPI_BASE_URL = '/_hotels/api';

export const WHERE_CAN_USE_CROSS_SEARCH: RenderContext[] = ['ott', 'main'];
export const WHERE_RESUBMIT_IS_NEEDED_AFTER_MULTIROOM_POPUP: RenderContext[] = ['serp', 'offers'];

export const QUERY_PARAMS_FOR_SERP_ONLY = [
  'adults',
  'children',
  'childrenAges',
  'stars',
  'types',
  'themes',
  'payType',
  'rating',
  'facilities',
  'chain',
  'price',
  'hotelSearchName',
  'sortType',
  'specifySearchParams',
];

/**
 * Ключи поменял, потому что формат данных тоже поменялся
 * и решил сразу на будущее добавить "типа" версионирование
 */
export const HOTELS_LAST_SEARCH_KEY = '__ott_hotels_lastSearch_v1';
export const HOTELS_SEARCH_HISTORY_KEY = '__ott_hotels_searchHistory_v1';
export const HOTELS_SEARCH_HISTORY_MAX_RECORDS = 3;

export const trackingTypes = {
  multiroomPopup: {
    shown: 'ott/hotels/TRACK_SHOW_MROOM_POPUP',
    applied: 'ott/hotels/TRACK_APPLY_MROOM_POPUP',
    left: 'ott/hotels/TRACK_LEAVE_MROOM_POPUP',
  },
  destinationChanged: 'ott/hotels/DESTINATION_CHANGED',
  datesChanged: 'ott/hotels/DATES_CHANGED',
  roomsChanged: 'ott/hotels/ROOMS_CHANGED',
};

export const DATE_FORMAT = 'yyyy-MM-dd';

export const STD_CHECKIN_FROM_TIME = 14;
export const STD_CHECKOUT_TO_TIME = 12;

export const EARLY_CHECKIN_ITEMS = getTimeItems(0, STD_CHECKIN_FROM_TIME);
export const LATE_CHECKOUT_ITEMS = getTimeItems(STD_CHECKOUT_TO_TIME + 1, 24);
